<template>
  <div>
    <!-- Bahagian Atas (13%) — Hanya kelihatan di desktop -->
    <div class="bg-white desktop-header" style="height: 13vh; position: relative;">
      <div
        style="position: absolute; top: 10px; left: 10px; right: 10px; display: flex; align-items: center; justify-content: space-between;">
        <div class="d-flex align-items-center">
          <img src="img/brand/jata_jpm.png" alt="Jata Negara" style="width: 120px; height: auto; max-width: 120px;">
          <img src="img/brand/madani.png" alt="Malaysia Madani"
            style="width: 150px; height: auto; max-width: 150px; margin-left: 10px;">
        </div>
        <div style="text-align: center; flex-grow: 1;">
          <h1 class="mb-0 text-dark font-weight-bold system-title" style="font-size: clamp(1rem, 2vw, 2rem);">
            <strong>SISTEM <br> DASHBOARD H.E.M.A.T.</strong>
          </h1>
        </div>
        <div style="width: 180px; text-align: right;">
          <a :href="portalURL" class="btn btn-outline-primary btn-sm portal-link"
            style="border-radius: 20px; padding: 5px 15px; font-weight: bold; border-width: 2px;">
            <i class="fas fa-arrow-left"></i> Kembali ke Portal H.E.M.A.T.
          </a>
        </div>
      </div>
    </div>

    <!-- Garisan Pemisah -->
    <hr style="border: 2px solid black; margin: 0;">

    <!-- Bahagian Bawah (80%) -->
    <div class="bg-white" style="min-height: 86.5vh; display: flex; flex-direction: column; justify-content: center;">
      <b-container style="padding: 20px 0;">
        <b-row class="align-items-center">
          <!-- Logo HEMAT dan Nama Sistem di Sebelah Kiri -->
          <b-col lg="6" md="6"
            class="d-flex flex-column align-items-center justify-content-center text-center mb-4 mb-md-0">
            <img src="img/brand/hemat_c.png" alt="HEMAT Logo" style="width: 100%; max-width: 500px; height: auto;"
              class="mb-4">
          </b-col>

          <!-- Kotak Login di Sebelah Kanan -->
          <b-col lg="5" md="6" sm="12" class="mx-auto ml-lg-5">
            <b-card no-body class="shadow-lg border-0"
              style="background-color: #d3d3d3; border-radius: 30px !important;">
              <b-card-header class="bg-transparent text-center py-3 py-lg-4" style="border-bottom: none;">
                <h1 class="mb-0" style="font-size: clamp(1.2rem, 2vw, 1.8rem);">LOG MASUK</h1>
              </b-card-header>

              <!-- Login Tabs -->
              <b-tabs content-class="mt-3" nav-class="login-tabs" active-nav-item-class="active-tab">
                <!-- HRMIS Tab -->
                <b-tab title="HRMIS" active>
                  <template #title>
                    <div class="d-flex align-items-center justify-content-center">
                      <i class="fas fa-building mr-2"></i>
                      <span>HRMIS</span>
                    </div>
                  </template>
                  <b-card-body class="px-3 px-lg-4 py-3 py-lg-4">
                    <p class="text-center mb-4" style="font-size: clamp(0.8rem, 1.5vw, 1rem); font-weight: 300;">
                      Sila masukkan No. Kad Pengenalan dan Kata Laluan seperti di sistem HRMIS.
                    </p>
                    <validation-observer v-slot="{ handleSubmit }" ref="formValidatorHrmis">
                      <b-form role="form" @submit.prevent="handleSubmit(onSubmitHrmis)">
                        <validation-provider name="icno" rules="required|min:12">
                          <base-input alternative class="mb-3" prepend-icon="fas fa-user"
                            placeholder="No Kad Pengenalan" name="icno" v-model="model.icno"
                            @input="model.icno = model.icno.replace(/[^0-9]/g, '').slice(0, 12)">
                            <template #error>
                              <!-- <div class="text-danger">{{ errors[0] }}</div> -->
                            </template>
                          </base-input>
                        </validation-provider>

                        <validation-provider name="password" rules="required|min:6">
                          <base-input alternative class="mb-3" :type="showPassword ? 'text' : 'password'"
                            placeholder="Kata Laluan" name="password" v-model="model.password">
                            <template #prepend>
                              <b-icon :icon="showPassword ? 'eye-slash' : 'eye'" @click="togglePasswordVisibility"
                                style="cursor: pointer;" />
                            </template>
                            <template #error>
                              <!-- <div class="text-danger">{{ errors[0] }}</div> -->
                            </template>
                          </base-input>
                        </validation-provider>

                        <div class="text-center">
                          <base-button type="primary" native-type="submit" class="btn btn-primary btn-block mb-3"
                            style="padding: 10px;">
                            Log Masuk
                          </base-button>
                        </div>
                      </b-form>
                    </validation-observer>

                    <!-- Kotak Makluman HRMIS -->
                    <div class="text-center mb-4"
                      style="background-color: #d3d3d3; border: 2px solid #000000; padding: 10px 15px; border-radius: 10px;">
                      <p style="color: #000000; font-size: clamp(0.8rem, 1.2vw, 0.9rem); margin: 0; font-weight: bold;">
                        <strong>MAKLUMAN</strong>
                      </p>
                      <p
                        style="color: #000000; font-size: clamp(0.7rem, 1.1vw, 0.9rem); margin: 5px 0; text-align: left; text-indent: -1.2em; padding-left: 1.2em;">
                        1. Sila hubungi <strong><b>03-8885 3916</b></strong> sekiranya menghadapi masalah untuk log
                        masuk ke
                        sistem
                      </p>
                      <p
                        style="color: #000000; font-size: clamp(0.7rem, 1.1vw, 0.9rem); margin: 0; text-align: left; text-indent: -1.2em; padding-left: 1.2em;">
                        2. Sebarang tindakan kemaskini dan set semula kata laluan perlu diambil tindakan di Sistem HRMIS
                        2.0.
                      </p>
                    </div>
                  </b-card-body>
                </b-tab>

                <!-- Public/Orang Awam Tab -->
                <b-tab title="Orang Awam">
                  <template #title>
                    <div class="d-flex align-items-center justify-content-center">
                      <i class="fas fa-users mr-2"></i>
                      <span>Bukan HRMIS</span>
                    </div>
                  </template>
                  <b-card-body class="px-3 px-lg-4 py-3 py-lg-4">
                    <p class="text-center mb-4" style="font-size: clamp(0.8rem, 1.5vw, 1rem); font-weight: 300;">
                      Sila masukkan No. Kad Pengenalan dan Kata Laluan untuk log masuk Bukan HRMIS.
                    </p>

                    <validation-observer v-slot="{ handleSubmit }" ref="formValidatorPublic">
                      <b-form role="form" @submit.prevent="handleSubmit(onSubmitPublic)">
                        <validation-provider name="icNumber" rules="required|exact_12_digits">
                          <base-input alternative class="mb-3" prepend-icon="fas fa-id-card"
                            placeholder="No. Kad Pengenalan" name="icNumber" v-model="publicModel.icNumber" type="text"
                            @input="publicModel.icNumber = publicModel.icNumber.replace(/[^0-9]/g, '').slice(0, 12)">
                            <template #error>
                              <!-- Error message handled by vee-validate -->
                            </template>
                          </base-input>
                        </validation-provider>

                        <validation-provider name="password" rules="required|min:6">
                          <base-input alternative class="mb-3" :type="showPasswordPublic ? 'text' : 'password'"
                            placeholder="Kata Laluan" name="password" v-model="publicModel.password">
                            <template #prepend>
                              <b-icon :icon="showPasswordPublic ? 'eye-slash' : 'eye'"
                                @click="togglePasswordVisibilityPublic" style="cursor: pointer;" />
                            </template>
                            <template #error>
                              <!-- <div class="text-danger">{{ errors[0] }}</div> -->
                            </template>
                          </base-input>
                        </validation-provider>

                        <div class="text-center">
                          <base-button type="primary" native-type="submit" class="btn btn-primary btn-block mb-3"
                            style="padding: 10px;">
                            Log Masuk
                          </base-button>
                          <button type="button" @click="forgotPassword" class="btn btn-link text-muted"
                            style="text-decoration: none;">
                            <i class="fas fa-key mr-1"></i> Lupa Kata Laluan
                          </button>
                        </div>
                      </b-form>
                    </validation-observer>

                    <!-- Register Button for Public -->
                    <!-- <div class="text-center mb-4">
                      <p class="text-muted mb-2" style="font-size: 0.9rem;">Belum mempunyai akaun?</p>
                      <base-button type="outline" class="btn btn-outline-primary btn-block"
                        style="padding: 8px; border-width: 2px;" @click="goToRegister">
                        <i class="fas fa-user-plus mr-2"></i> Daftar Pengguna
                      </base-button>
                    </div> -->

                    <!-- Kotak Makluman Orang Awam -->
                    <div class="text-center mb-4"
                      style="background-color: #d3d3d3; border: 2px solid #000000; padding: 10px 15px; border-radius: 10px;">
                      <p style="color: #000000; font-size: clamp(0.8rem, 1.2vw, 0.9rem); margin: 0; font-weight: bold;">
                        <strong>MAKLUMAN</strong>
                      </p>
                      <p
                        style="color: #000000; font-size: clamp(0.7rem, 1.1vw, 0.9rem); margin: 5px 0; text-align: left; text-indent: -1.2em; padding-left: 1.2em;">
                        1. Sila hubungi <strong><b>03-8885 3916</b></strong> sekiranya menghadapi masalah untuk log
                        masuk ke
                        sistem
                      </p>
                      <p
                        style="color: #000000; font-size: clamp(0.7rem, 1.1vw, 0.9rem); margin: 0; text-align: left; text-indent: -1.2em; padding-left: 1.2em;">
                        2. Pengguna Bukan HRMIS perlu mendaftar akaun terlebih dahulu sebelum boleh log masuk ke sistem.
                      </p>
                    </div>
                    <!-- Dalam tab Orang Awam, tambah modal untuk Lupa Kata Laluan -->
                    <b-modal id="forgotPasswordModal" size="md" title="Lupa Kata Laluan" hide-footer centered>
                      <validation-observer v-slot="{ handleSubmit }" ref="forgotPasswordValidator">
                        <b-form @submit.prevent="handleSubmit(submitForgotPassword)">
                          <validation-provider name="icNumber" rules="required|exact_12_digits" v-slot="{ errors }">
                            <base-input alternative class="mb-3" prepend-icon="fas fa-id-card"
                              placeholder="No. Kad Pengenalan" name="icNumber" v-model="forgotPasswordModel.icNumber"
                              type="text" :error="errors[0]"
                              @input="forgotPasswordModel.icNumber = forgotPasswordModel.icNumber.replace(/[^0-9]/g, '').slice(0, 12)">
                            </base-input>
                          </validation-provider>

                          <validation-provider name="email" rules="required|email" v-slot="{ errors }">
                            <base-input alternative class="mb-3" prepend-icon="fas fa-envelope"
                              placeholder="Alamat Emel" name="email" v-model="forgotPasswordModel.email" type="email"
                              :error="errors[0]">
                            </base-input>
                          </validation-provider>

                          <div class="text-center">
                            <base-button type="primary" native-type="submit" class="btn btn-primary btn-block mb-3"
                              :loading="loadingForgotPassword">
                              <span v-if="!loadingForgotPassword">Hantar Permohonan</span>
                              <span v-else>Memproses...</span>
                            </base-button>
                          </div>
                        </b-form>
                      </validation-observer>
                    </b-modal>

                    <!-- Modal Kata Laluan Ditukar -->
                    <b-modal id="passwordResetModal" size="md" title="Tukar Kata Laluan" hide-footer centered>
                      <div class="text-center">
                        <i class="fas fa-check-circle text-success mb-3" style="font-size: 3rem;"></i>
                        <h4 class="text-success">Berjaya!</h4>
                        <p>Kata laluan anda telah dihantar ke emel </p>
                        <p><strong>{{ forgotPasswordModel.email }}</strong></p>
                        <p class="text-muted">Sila semak emel anda dan log masuk dengan kata laluan baharu.</p>
                        <base-button type="primary" class="mt-3" @click="$bvModal.hide('passwordResetModal')">
                          Tutup
                        </base-button>
                      </div>
                    </b-modal>
                    <!-- Modal Pendaftaran Pengguna Awam -->
                    <b-modal id="publicRegistrationModal" size="md" title="Pendaftaran Pengguna Awam" hide-footer
                      centered>
                      <validation-observer v-slot="{ handleSubmit }" ref="publicRegistrationValidator">
                        <b-form @submit.prevent="handleSubmit(submitPublicRegistration)">
                          <validation-provider name="icNumber" rules="required|exact_12_digits" v-slot="{ errors }">
                            <base-input alternative class="mb-3" prepend-icon="fas fa-id-card"
                              placeholder="No. Kad Pengenalan" name="icNumber"
                              v-model="publicRegistrationModel.icNumber" type="text" :error="errors[0]" disabled>
                            </base-input>
                          </validation-provider>

                          <validation-provider name="nama" rules="required" v-slot="{ errors }">
                            <base-input alternative class="mb-3" prepend-icon="fas fa-user" placeholder="Nama Penuh"
                              name="nama" v-model="publicRegistrationModel.nama" type="text" :error="errors[0]">
                            </base-input>
                          </validation-provider>

                          <validation-provider name="email" rules="required|email" v-slot="{ errors }">
                            <base-input alternative class="mb-3" prepend-icon="fas fa-envelope"
                              placeholder="Alamat Emel" name="email" v-model="publicRegistrationModel.email"
                              type="email" :error="errors[0]">
                            </base-input>
                          </validation-provider>

                          <validation-provider name="agensi" rules="required" v-slot="{ errors }">
                            <base-input alternative class="mb-3" prepend-icon="fas fa-building" placeholder="Agensi"
                              name="agensi" v-model="publicRegistrationModel.agensi" type="text" :error="errors[0]"
                              @input="publicRegistrationModel.agensi = publicRegistrationModel.agensi.toUpperCase()"
                              style="text-transform: uppercase;">
                            </base-input>
                          </validation-provider>

                          <validation-provider name="telefon" rules="required" v-slot="{ errors }">
                            <base-input alternative class="mb-3" prepend-icon="fas fa-phone" placeholder="No. Telefon"
                              name="telefon" v-model="publicRegistrationModel.telefon" type="tel" :error="errors[0]">
                            </base-input>
                          </validation-provider>

                          <validation-provider name="password" rules="required|min:6" v-slot="{ errors }"
                            vid="password">
                            <base-input alternative class="mb-3" :type="showPasswordRegister ? 'text' : 'password'"
                              placeholder="Kata Laluan" name="password" v-model="publicRegistrationModel.password"
                              :error="errors[0]">
                              <template #prepend>
                                <b-icon :icon="showPasswordRegister ? 'eye-slash' : 'eye'"
                                  @click="togglePasswordVisibilityRegister" style="cursor: pointer;" />
                              </template>
                            </base-input>
                          </validation-provider>

                          <validation-provider name="confirmPassword" rules="required|confirmed:password"
                            v-slot="{ errors }">
                            <base-input alternative class="mb-3" :type="showPasswordRegister ? 'text' : 'password'"
                              placeholder="Sahkan Kata Laluan" name="confirmPassword"
                              v-model="publicRegistrationModel.confirmPassword" :error="errors[0]">
                              <template #prepend>
                                <b-icon :icon="showPasswordRegister ? 'eye-slash' : 'eye'"
                                  @click="togglePasswordVisibilityRegister" style="cursor: pointer;" />
                              </template>
                            </base-input>
                          </validation-provider>

                          <div class="text-center">
                            <base-button type="primary" native-type="submit" class="btn btn-primary btn-block mb-3"
                              :loading="loadingPublicRegistration"
                              :disabled="!publicRegistrationModel.password || !publicRegistrationModel.confirmPassword || publicRegistrationModel.password !== publicRegistrationModel.confirmPassword">
                              <span v-if="!loadingPublicRegistration">Daftar</span>
                              <span v-else>Memproses...</span>
                            </base-button>
                            <base-button type="secondary" class="btn btn-secondary btn-block"
                              @click="$bvModal.hide('publicRegistrationModal')">
                              Batal
                            </base-button>
                          </div>
                        </b-form>
                      </validation-observer>
                    </b-modal>
                    <!-- Modal Reset Password -->
                    <b-modal id="resetPasswordModal" size="md" title="Tukar Kata Laluan" hide-footer centered
                      @hidden="onResetModalHidden">
                      <validation-observer v-slot="{ handleSubmit, invalid }" ref="resetPasswordValidator">
                        <b-form @submit.prevent="handleSubmit(submitResetPassword)">
                          <p class="text-muted mb-3">Sila tetapkan kata laluan baharu untuk akaun anda.</p>

                          <!-- Input Kata Laluan Baharu -->
                          <validation-provider name="newPassword" rules="required|min:12|password_complexity"
                            v-slot="{ errors }" vid="newPassword">
                            <b-form-group>
                              <label for="newPassword" class="form-label">Kata Laluan Baharu</label>
                              <b-input-group>
                                <b-input-group-prepend>
                                  <b-input-group-text style="cursor: pointer; background-color: #f8f9fa;"
                                    @click="showNewPassword = !showNewPassword">
                                    <b-icon :icon="showNewPassword ? 'eye-slash' : 'eye'" />
                                  </b-input-group-text>
                                </b-input-group-prepend>
                                <b-form-input id="newPassword" v-model="resetPasswordModel.newPassword"
                                  :type="showNewPassword ? 'text' : 'password'" placeholder="Kata Laluan Baharu"
                                  name="newPassword" :state="errors.length > 0 ? false : null"
                                  @input="checkPasswordStrength(); checkPasswordMatch()" @focus="showTooltip = true"
                                  @blur="showTooltip = false" />
                              </b-input-group>

                              <!-- Tooltip (aktif kekal) -->
                              <div v-if="showTooltip" class="custom-tooltip"
                                style="background: #f8f9fa; padding: 10px; border-radius: 5px; margin-top: 5px; border: 1px solid #dee2e6;">
                                <p style="font-size: 0.8rem; font-weight: bold; margin-bottom: 5px; color: #1e3a8a;">
                                  Kata laluan mesti sekurang-kurangnya 12 aksara dan mesti mengandungi
                                  sekurang-kurangnya 1 huruf besar,
                                  1 huruf kecil, 1 nombor dan 1 aksara khas (contohnya, @)
                                </p>
                                <ul style="text-align: left; padding-left: 15px; margin: 0; list-style: none;">
                                  <li v-for="(req, index) in passwordRequirements" :key="index"
                                    :class="{ 'text-success': req.met, 'text-danger': !req.met }"
                                    style="font-size: 0.75rem; margin-bottom: 3px;">
                                    <i :class="req.met ? 'fas fa-check-circle' : 'fas fa-times-circle'"></i>
                                    {{ req.text }}
                                  </li>
                                </ul>
                              </div>

                              <!-- HIDE default validation error -->
                              <div v-if="false" class="text-danger mt-1" style="font-size: 0.8rem;">
                                <i class="fas fa-exclamation-circle"></i> {{ errors[0] }}
                              </div>
                            </b-form-group>
                          </validation-provider>

                          <!-- Input Sahkan Kata Laluan Baharu -->
                          <validation-provider name="confirmNewPassword" rules="required|confirmed:newPassword"
                            v-slot="{ errors }">
                            <b-form-group>
                              <label for="confirmNewPassword" class="form-label">Sahkan Kata Laluan Baharu</label>
                              <b-input-group>
                                <b-input-group-prepend>
                                  <b-input-group-text style="cursor: pointer; background-color: #f8f9fa;"
                                    @click="showNewPassword = !showNewPassword">
                                    <b-icon :icon="showNewPassword ? 'eye-slash' : 'eye'" />
                                  </b-input-group-text>
                                </b-input-group-prepend>

                                <b-form-input id="confirmNewPassword" v-model="resetPasswordModel.confirmNewPassword"
                                  :type="showNewPassword ? 'text' : 'password'" placeholder="Sahkan Kata Laluan Baharu"
                                  name="confirmNewPassword" :state="errors.length > 0 ? false : null"
                                  @input="checkPasswordMatch()" />
                              </b-input-group>

                              <!-- Mesej tersuai jika tidak sepadan -->
                              <div v-if="!passwordsMatch && resetPasswordModel.confirmNewPassword"
                                class="text-danger mt-1" style="font-size: 0.8rem;">
                                <i class="fas fa-exclamation-circle"></i> Kata laluan tidak sepadan
                              </div>

                              <!-- Sembunyikan mesej error asal -->
                              <div v-if="false" class="text-danger mt-1" style="font-size: 0.8rem;">
                                <i class="fas fa-exclamation-circle"></i> {{ errors[0] }}
                              </div>
                            </b-form-group>
                          </validation-provider>


                          <div class="text-center mt-4">
                            <base-button type="primary" native-type="submit" class="btn btn-primary btn-block mb-3"
                              :loading="loadingResetPassword"
                              :disabled="!passwordsMatch || invalid || loadingResetPassword || passwordStrength < 100">
                              <span v-if="!loadingResetPassword">Tukar Kata Laluan</span>
                              <span v-else>Memproses...</span>
                            </base-button>

                            <div v-if="passwordStrength < 100" class="alert alert-warning py-2"
                              style="font-size: 0.8rem;">
                              <i class="fas fa-exclamation-triangle"></i>
                              Sila penuhi semua keperluan keselamatan kata laluan sebelum meneruskan.
                            </div>
                          </div>
                        </b-form>
                      </validation-observer>
                    </b-modal>
                    <!-- Modal Kata Laluan Berjaya Ditukar -->
                    <b-modal id="passwordChangedSuccessModal" size="md" title="Kata Laluan Berjaya Ditukar" hide-footer
                      centered>
                      <div class="text-center">
                        <i class="fas fa-check-circle text-success mb-3" style="font-size: 3rem;"></i>
                        <h4 class="text-success">Berjaya!</h4>
                        <p>Kata laluan anda telah berjaya ditukar.</p>
                        <p class="text-muted">Sila log masuk semula dengan kata laluan baharu.</p>
                        <base-button type="primary" class="mt-3" @click="closeAndRedirect">
                          Tutup
                        </base-button>
                      </div>
                    </b-modal>
                  </b-card-body>
                </b-tab>
              </b-tabs>


              <!-- Kembali ke Portal Link for Mobile -->
              <div class="text-center d-lg-none mt-4 px-3">
                <a :href="portalURL" class="btn btn-outline-primary portal-link"
                  style="border-radius: 25px; padding: 8px 20px; font-weight: bold; border-width: 2px; background: linear-gradient(87deg, #1e3a8a 0%, #1a2b5d 100%); color: white; transition: all 0.3s ease;">
                  <i class="fas fa-arrow-left"></i> Kembali ke Portal H.E.M.A.T.
                </a>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="base-input">
      <b-input-group>
        <template v-if="$slots.prepend">
          <b-input-group-prepend>
            <slot name="prepend"></slot>
          </b-input-group-prepend>
        </template>
        <b-form-input v-bind="$attrs" :value="value" @input="$emit('input', $event)"
          :class="{ 'is-invalid': error }"></b-form-input>
      </b-input-group>
      <div v-if="error" class="text-danger">{{ error }}</div>
    </div>
  </div>

</template>

<script>
import Swal from 'sweetalert2';
import Store from '@/store';
import login_service from '@/services/login_service.js';
import { extend } from 'vee-validate';
import { required, min, email } from 'vee-validate/dist/rules';
import { portalURL } from '@/services/baseURL.js';

// Takrifkan peraturan vee-validate
extend('email', {
  ...email,
  message: 'Format emel tidak sah'
});

extend('exact_12_digits', {
  validate: value => /^\d{12}$/.test(value),
  message: 'No Kad Pengenalan mestilah 12 digit nombor'
});

extend('required', {
  ...required,
  message: (field) => {
    const fieldLabels = {
      icno: 'No Kad Pengenalan',
      password: 'Kata Laluan',
      icNumber: 'No Kad Pengenalan',
      nama: 'Nama Penuh',
      email: 'Alamat Emel',
      agensi: 'Agensi',
      telefon: 'No. Telefon',
      confirmPassword: 'Sahkan Kata Laluan'
    };
    return `${fieldLabels[field] || field} diperlukan`;
  }
});

extend('numeric', {
  validate: value => !isNaN(value) && value.length === 12,
  message: 'No Kad Pengenalan mestilah 12 digit nombor'
});

extend('min', {
  ...min,
  message: (field, { length }) => {
    const fieldLabels = {
      icno: 'No Kad Pengenalan',
      password: 'Kata Laluan'
    };
    return `${fieldLabels[field] || field} mestilah sekurang-kurangnya ${length} aksara`;
  }
});
extend('password_complexity', {
  validate: value => {
    if (!value) return false;
    return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{12,}$/.test(value);
  },
  message: 'Kata laluan mesti memenuhi semua keperluan keselamatan'
});
export default {
  data() {
    return {
      showTooltip: false,
      passwordStrength: 0,
      passwordRequirements: [
        { text: '12 jumlah aksara', met: false, regex: /.{12,}/ },
        { text: 'Huruf besar', met: false, regex: /[A-Z]/ },
        { text: 'Huruf kecil', met: false, regex: /[a-z]/ },
        { text: 'Nombor', met: false, regex: /[0-9]/ },
        { text: 'Aksara khas (contohnya, @)', met: false, regex: /[@$!%*?&]/ }
      ],
      portalURL,
      model: {
        icno: '',
        password: ''
      },
      publicModel: {
        icNumber: '',
        password: ''
      },
      forgotPasswordModel: {
        icNumber: '',
        email: ''
      },
      publicRegistrationModel: {
        icNumber: '',
        nama: '',
        email: '',
        agensi: '',
        telefon: '',
        password: '',
        confirmPassword: ''
      },
      resetPasswordModel: {
        newPassword: '',
        confirmNewPassword: ''
      },
      showNewPassword: false,
      loadingResetPassword: false,
      userNeedsReset: false,
      userToReset: null,
      passwordsMatch: false,
      showPassword: false,
      showPasswordPublic: false,
      showPasswordRegister: false,
      loadingForgotPassword: false,
      loadingPublicRegistration: false,
      defaultPassword: 'hemat123'
    };
  },
  methods: {
    closeAndRedirect() {
      this.$bvModal.hide('passwordChangedSuccessModal');
      // Redirect ke halaman utama atau senarai projek
      this.$router.push('/senarai-projek').catch(() => { });
    },
    checkPasswordStrength() {
      const password = this.resetPasswordModel.newPassword;

      // Reset semua requirements
      this.passwordRequirements.forEach(req => {
        req.met = req.regex.test(password);
      });

      // Kira strength berdasarkan requirements yang dipenuhi
      const metCount = this.passwordRequirements.filter(req => req.met).length;
      this.passwordStrength = (metCount / this.passwordRequirements.length) * 100;
    },


    async checkUserExistence(icNumber) {
      try {
        const [userResponse, hrmisResponse] = await Promise.all([
          login_service.checkuser(icNumber).catch(() => ({ data: { status: 'error' } })),
          login_service.checkHRMIS(icNumber).catch(() => ({ data: { status: 'error' } }))
        ]);

        const userExists = userResponse.data.status === 'success' && userResponse.data.exists;
        const hasHRMISData = hrmisResponse.data.status === 'success' && hrmisResponse.data.hasHRMISData;

        return {
          userExists,
          hasHRMISData,
          userType: hasHRMISData ? 'hrmis' : (userExists ? 'public' : 'none')
        };
      } catch (error) {
        return {
          userExists: false,
          hasHRMISData: false,
          userType: 'none'
        };
      }
    },
    async checkUserType(icNumber) {
      try {
        const [userResponse, hrmisResponse] = await Promise.all([
          login_service.checkuser(icNumber).catch(() => ({ data: { status: 'error' } })),
          login_service.checkHRMIS(icNumber).catch(() => ({ data: { status: 'error' } }))
        ]);

        const userExists = userResponse.data.status === 'success' && userResponse.data.exists;
        const hasHRMISData = hrmisResponse.data.status === 'success' && hrmisResponse.data.hasHRMISData;

        if (hasHRMISData) {
          return 'hrmis';
        } else if (userExists) {
          return 'public';
        } else {
          return 'none';
        }
      } catch (error) {
        return 'none';
      }
    },
    validateNewPassword() {
      const password = this.resetPasswordModel.newPassword;
      if (password.length < 6) {
        return 'Kata laluan mestilah sekurang-kurangnya 6 aksara';
      }
      if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/.test(password)) {
        return 'Kata laluan mestilah mengandungi huruf besar, huruf kecil dan nombor';
      }
      return null;
    },
    onResetModalHidden() {
      // Jika modal ditutup tanpa menukar password, log out pengguna
      if (this.userNeedsReset) {
        this.publicModel.password = '';
        this.userNeedsReset = false;
      }
    },
    handlePostResetRedirect() {
      // Pastikan pengguna log masuk semula dengan kata laluan baru
      this.publicModel.icNumber = this.userToReset.icNumber;
      this.publicModel.password = '';

      // Tunjukkan mesej untuk log masuk semula
      Swal.fire({
        title: 'Sila Log Masuk Semula',
        text: 'Sila log masuk dengan kata laluan baharu anda.',
        icon: 'info',
        confirmButtonText: 'OK'
      }).then(() => {
        // Fokuskan semula ke field password
        this.$nextTick(() => {
          const passwordField = this.$el.querySelector('input[name="password"]');
          if (passwordField) {
            passwordField.focus();
          }
        });
      });
    },
    checkPasswordMatch() {
      this.passwordsMatch = this.resetPasswordModel.newPassword === this.resetPasswordModel.confirmNewPassword;
    },
    validatePasswordComplexity() {
      const password = this.resetPasswordModel.newPassword;
      return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{12,}$/.test(password);
    },
    togglePasswordVisibilityRegister() {
      this.showPasswordRegister = !this.showPasswordRegister;
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    togglePasswordVisibilityPublic() {
      this.showPasswordPublic = !this.showPasswordPublic;
    },
    forgotPassword() {
      // Kosongkan form dan tunjuk modal
      this.forgotPasswordModel.icNumber = '';
      this.forgotPasswordModel.email = '';
      this.$bvModal.show('forgotPasswordModal');
    },
    async submitForgotPassword() {
      this.loadingForgotPassword = true;

      try {
        const response = await login_service.forgotPassword({
          icNumber: this.forgotPasswordModel.icNumber,
          email: this.forgotPasswordModel.email
        });

        // Periksa status response dengan betul
        if (response.data && response.data.status === 'success') {
          // Berjaya - reset password
          this.defaultPassword = (response.data.data && response.data.data.newPassword) || '';
          this.$bvModal.hide('forgotPasswordModal');
          this.$bvModal.show('passwordResetModal');
        } else {
          // Gagal - tunjuk error message dari backend
          Swal.fire({
            title: 'Tidak Berjaya!',
            text: (response.data && response.data.message) || 'No. Kad Pengenalan dan Emel tidak sepadan.',
            icon: 'error',
            confirmButtonText: 'OK'
          });
        }
      } catch (error) {
        // Hanya tangkap actual network errors atau server errors
        // console.error('Network/Server error in forgot password:', error);

        let errorMessage = 'Terdapat masalah teknikal. Sila cuba lagi kemudian.';

        // Periksa jika error ada response data
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        } else if (error.message) {
          errorMessage = error.message;
        }

        Swal.fire({
          title: 'Ralat!',
          text: errorMessage,
          icon: 'error',
          confirmButtonText: 'OK'
        });
      } finally {
        this.loadingForgotPassword = false;
      }
    },
    goToRegister() {
      Swal.fire({
        title: 'Daftar Pengguna',
        text: 'Sila masukkan nombor kad pengenalan anda untuk semakan sebelum mendaftar.',
        input: 'text',
        inputAttributes: {
          autocapitalize: 'off',
          placeholder: 'contoh: 880808015555',
          maxlength: '12',
          pattern: '[0-9]*',
          inputmode: 'numeric',
          oninput: 'this.value = this.value.replace(/[^0-9]/g, "").slice(0, 12)'
        },
        showCancelButton: true,
        confirmButtonText: 'Semak',
        cancelButtonText: 'Batal',
        showLoaderOnConfirm: true,
        preConfirm: (icNumber) => {
          if (!/^\d{12}$/.test(icNumber)) {
            Swal.showValidationMessage('No. Kad Pengenalan mestilah 12 digit nombor sahaja');
            return false;
          }
          return Promise.all([
            login_service.checkuser(icNumber).catch(error => ({ error: error.message || 'Ralat semasa semakan pengguna' })),
            login_service.checkHRMIS(icNumber).catch(error => ({ error: error.message || 'Ralat semasa semakan HRMIS' }))
          ])
            .then(([userResponse, hrmisResponse]) => {
              if (userResponse.error || hrmisResponse.error) {
                throw new Error(userResponse.error || hrmisResponse.error);
              }

              const userExists = userResponse.data.status === 'success' && userResponse.data.exists;
              const hasHRMISData = hrmisResponse.data.status === 'success' && hrmisResponse.data.hasHRMISData;

              if (userExists || hasHRMISData) {
                return {
                  icNumber,
                  userType: 'hrmis',
                  message: 'No. Kad Pengenalan ini wujud dalam sistem HRMIS atau sistem lain. Anda tidak perlu mendaftar sebagai Bukan HRMIS.'
                };
              } else {
                return {
                  icNumber,
                  userType: 'public',
                  message: 'No. Kad Pengenalan ini tidak wujud dalam sistem. Anda boleh mendaftar sebagai pengguna Bukan HRMIS.'
                };
              }
            })
            .catch(error => {
              throw new Error(error.message || 'Ralat semasa membuat semakan. Sila cuba lagi.');
            });
        },
        allowOutsideClick: () => !Swal.isLoading()
      }).then((result) => {
        if (result.isConfirmed) {
          const { icNumber, userType, message } = result.value;

          if (userType === 'hrmis') {
            Swal.fire({
              title: 'Pengguna HRMIS',
              text: message,
              icon: 'info',
              confirmButtonText: 'OK'
            });
          } else {
            this.showPublicRegistrationModal(icNumber);
          }
        }
      }).catch((error) => {
        Swal.fire({
          title: 'Tidak Berjaya!',
          text: error.message || 'Ralat semasa membuat semakan. Sila cuba lagi.',
          icon: 'error',
          confirmButtonText: 'OK'
        });
      });
    },
    showPublicRegistrationModal(icNumber) {
      // Kosongkan model dan set icNumber
      this.publicRegistrationModel = {
        icNumber,
        nama: '',
        email: '',
        agensi: '',
        telefon: '',
        password: '',
        confirmPassword: ''
      };
      this.$bvModal.show('publicRegistrationModal');
    },
    async submitPublicRegistration() {
      this.loadingPublicRegistration = true;
      // console.log('Password:', this.publicRegistrationModel.password);
      // console.log('Confirm Password:', this.publicRegistrationModel.confirmPassword);

      try {
        const registrationData = {
          icNumber: this.publicRegistrationModel.icNumber,
          nama: this.publicRegistrationModel.nama,
          emel: this.publicRegistrationModel.email,
          agensi: this.publicRegistrationModel.agensi,
          telefon: this.publicRegistrationModel.telefon,
          password: this.publicRegistrationModel.password
        };

        const response = await login_service.registerPublic(registrationData);

        if (response.data.status === 'success') {
          this.$bvModal.hide('publicRegistrationModal');
          Swal.fire({
            title: 'Pendaftaran Berjaya!',
            text: response.data.message || 'Akaun anda telah berjaya didaftarkan. Sila log masuk dengan maklumat yang telah didaftarkan.',
            icon: 'success',
            confirmButtonText: 'OK'
          }).then(() => {
            this.publicModel.icNumber = registrationData.icNumber;
            this.publicModel.password = '';
            // Berpindah ke tab Orang Awam
            this.$refs.formValidatorPublic.reset();
            this.$bvTabs.activeTab = 1; // Asumsi tab "Orang Awam" adalah tab kedua
          });
        } else {
          Swal.fire({
            title: 'Pendaftaran Gagal!',
            text: response.data.message || 'Ralat semasa pendaftaran. Sila cuba lagi.',
            icon: 'error',
            confirmButtonText: 'OK'
          });
        }
      } catch (error) {
        let errorMessage = 'Ralat semasa pendaftaran. Sila cuba lagi.';
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        }
        Swal.fire({
          title: 'Pendaftaran Gagal!',
          text: errorMessage,
          icon: 'error',
          confirmButtonText: 'OK'
        });
      } finally {
        this.loadingPublicRegistration = false;
      }
    },
    async registerPublicUser(registrationData) {
      try {
        // Password dihantar seperti biasa (frontend tidak melakukan hash)
        const response = await login_service.registerPublic(registrationData);

        if (response.data.status === 'success') {
          // TAMPILKAN NOTIFIKASI KEJAYAAN
          Swal.fire({
            title: 'Pendaftaran Berjaya!',
            text: response.data.message || 'Akaun anda telah berjaya didaftarkan. Sila log masuk dengan maklumat yang telah didaftarkan.',
            icon: 'success',
            confirmButtonText: 'OK'
          }).then(() => {
            this.publicModel.icNumber = registrationData.icNumber;
            this.publicModel.password = '';

            // Switch to public tab
            var publicTab = null;
            if (this.$refs.loginTabs && this.$refs.loginTabs[0] && this.$refs.loginTabs[0].$children) {
              publicTab = this.$refs.loginTabs[0].$children.find(function (tab) {
                return tab.title === 'Orang Awam';
              });
            }

            if (publicTab) {
              publicTab.activate();
            }
          });
        } else if (response.data.status === 'error') {
          // Tampilkan pesan error dari response
          Swal.fire({
            title: 'Pendaftaran Gagal!',
            text: response.data.message || 'Ralat semasa pendaftaran. Sila cuba lagi.',
            icon: 'error',
            confirmButtonText: 'OK'
          });
        }
      } catch (error) {
        // Tangani error jaringan atau error lainnya
        let errorMessage = 'Ralat semasa pendaftaran. Sila cuba lagi.';

        // Jika error memiliki response data
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        }

        Swal.fire({
          title: 'Pendaftaran Gagal!',
          text: errorMessage,
          icon: 'error',
          confirmButtonText: 'OK'
        });
      }
    },
    async onSubmitHrmis() {
      const requestData = {
        request: {
          userId: this.model.icno,
          password: this.model.password
        }
      };

      try {
        const response = await login_service.login(requestData);
        const $status = response.data.status;

        if ($status === 'success' && response.data.message === 'Login successful') {
          const { peranan } = response.data.data;
          const nama = response.data.data.second_api_response.table.response.MaklumatPegawai.Nama || 'Tidak diketahui';
          const buidagensi = response.data.data.second_api_response.table.response.MaklumatPegawai.BUIDAgensi || 'Tidak diketahui';
          const id = response.data.data.id;
          const valid = true;

          localStorage.setItem('user', JSON.stringify({ icno: this.model.icno, nama, peranan, buidagensi, id, valid }));
          Store.commit('setUser', { icno: this.model.icno, nama, peranan, buidagensi, id });
          Store.commit('saveToken', id);

          // KEKALKAN redirect ke profile dulu
          await this.$router.push('/profile');

          // KEMUDIAN redirect ke senarai-projek
          this.$router.push('/senarai-projek');

        } else if ($status === 'success' && response.data.message === 'Login successful but user not found in records') {
          Swal.fire({
            title: 'Login Tidak Berjaya!',
            text: 'Pengguna tidak wujud dalam sistem. Sila hubungi pentadbir untuk maklumat lanjut.',
            icon: 'warning',
            confirmButtonText: 'OK',
          });
        } else {
          Swal.fire({
            title: 'Login Tidak Berjaya!',
            text: response.data.message,
            icon: 'warning',
            confirmButtonText: 'OK',
          });
        }
      } catch (error) {
        // SEMAKAN BARU: Periksa jenis pengguna untuk mesej yang lebih spesifik
        const userCheck = await this.checkUserExistence(this.model.icno);

        if (userCheck.userType === 'public') {
          Swal.fire({
            title: 'Login Tidak Berjaya!',
            text: 'Anda bukan pengguna HRMIS. Sila log masuk melalui paparan log masuk Bukan HRMIS.',
            icon: 'warning',
            confirmButtonText: 'OK',
          });
        } else if (userCheck.userType === 'none') {
          Swal.fire({
            title: 'Login Tidak Berjaya!',
            text: 'Pengguna tidak wujud dalam sistem. Sila hubungi pentadbir untuk maklumat lanjut.',
            icon: 'warning',
            confirmButtonText: 'OK',
          });
        } else {
          Swal.fire({
            title: 'Login Tidak Berjaya!',
            text: 'Sila masukkan No. Kad Pengenalan dan Kata Laluan seperti di sistem HRMIS.',
            icon: 'error',
            confirmButtonText: 'OK',
          });
        }
      }
    },
    async fetchPublicProfile(userId) {
      try {
        // Panggil API untuk mendapatkan profil berdasarkan user_id (asumsi endpoint tersedia di login_service)
        // Contoh: login_service.getProfileByUserId(userId) yang mengembalikan data dari table profiles
        const profileResponse = await login_service.loginPublic(userId);
        if (profileResponse.data.status === 'success') {
          // console.log('Profile Response:', profileResponse.data.data.agency_id);
          return profileResponse.data.data.agency_id || 'Orang Awam'; // Ambil dari agency_id, fallback ke 'Orang Awam' jika tiada
        }
        return 'Orang Awam'; // Fallback jika API gagal
      } catch (error) {
        // console.error('Error fetching public profile:', error);
        return 'Orang Awam'; // Fallback jika error
      }
    },
    async onSubmitPublic() {
      const requestData = {
        request: {
          icNumber: this.publicModel.icNumber,
          password: this.publicModel.password
        }
      };

      try {
        const response = await login_service.loginPublic(requestData);
        const $status = response.data.status;

        if ($status === 'success') {
          const userData = response.data.data;

          // Check if reset_pass is required
          if (userData.resetRequired === true || userData.reset_pass === null) {
            this.userNeedsReset = true;
            this.userToReset = userData;
            this.$bvModal.show('resetPasswordModal');
            return;
          }

          // Ensure userType is 'public'
          if (userData.userType !== 'public') {
            Swal.fire({
              title: 'Login Tidak Berjaya!',
              text: 'Akaun ini bukan akaun Bukan HRMIS.',
              icon: 'warning',
              confirmButtonText: 'OK',
            });
            return;
          }

          // Use organisasi from API response for buidagensi
          const buidagensi = userData.organisasi || 'Orang Awam';

          const userDataForStorage = {
            icNumber: userData.icNumber,
            nama: userData.nama,
            peranan: userData.peranan,
            buidagensi: buidagensi,
            id: userData.id,
            valid: true,
            userType: userData.userType,
            emel: userData.emel,
            reset_pass: userData.reset_pass
          };

          localStorage.setItem('user', JSON.stringify(userDataForStorage));
          Store.commit('setUser', userDataForStorage);
          Store.commit('saveToken', userData.id);

          // KEKALKAN redirect ke profile dulu
          await this.$router.push('/profile');

          // KEMUDIAN redirect ke senarai-projek
          this.$router.push('/senarai-projek');

        } else {
          // SEMAKAN BARU: Periksa jenis pengguna untuk mesej yang lebih spesifik
          const userCheck = await this.checkUserExistence(this.publicModel.icNumber);

          if (userCheck.userType === 'hrmis') {
            Swal.fire({
              title: 'Login Tidak Berjaya!',
              text: 'Anda adalah pengguna HRMIS. Sila log masuk melalui paparan log masuk HRMIS.',
              icon: 'warning',
              confirmButtonText: 'OK',
            });
          } else if (userCheck.userType === 'none') {
            Swal.fire({
              title: 'Login Tidak Berjaya!',
              text: 'Pengguna tidak wujud dalam sistem. Sila hubungi pentadbir untuk maklumat lanjut.',
              icon: 'warning',
              confirmButtonText: 'OK',
            });
          } else {
            Swal.fire({
              title: 'Login Tidak Berjaya!',
              text: 'Sila masukkan No. Kad Pengenalan dan Kata Laluan untuk log masuk sebagai Bukan HRMIS.',
              icon: 'warning',
              confirmButtonText: 'OK',
            });
          }
        }
      } catch (error) {
        // SEMAKAN BARU: Periksa jenis pengguna untuk mesej yang lebih spesifik
        const userCheck = await this.checkUserExistence(this.publicModel.icNumber);

        if (userCheck.userType === 'hrmis') {
          Swal.fire({
            title: 'Login Tidak Berjaya!',
            text: 'Anda adalah pengguna HRMIS. Sila log masuk melalui paparan log masuk HRMIS.',
            icon: 'warning',
            confirmButtonText: 'OK',
          });
        } else if (userCheck.userType === 'none') {
          Swal.fire({
            title: 'Login Tidak Berjaya!',
            text: 'Pengguna tidak wujud dalam sistem. Sila hubungi pentadbir untuk maklumat lanjut.',
            icon: 'warning',
            confirmButtonText: 'OK',
          });
        } else {
          Swal.fire({
            title: 'Login Tidak Berjaya!',
            text: 'Sila masukkan No. Kad Pengenalan dan Kata Laluan untuk log masuk sebagai Bukan HRMIS.',
            icon: 'error',
            confirmButtonText: 'OK',
          });
        }
      }
    },
    async submitResetPassword() {
      this.loadingResetPassword = true;

      try {
        // 1. Semak sejarah kata laluan
        const historyCheck = await login_service.checkPasswordHistory({
          request: {  // <-- Tambah ini!
            icNumber: this.userToReset.icNumber,
            newPassword: this.resetPasswordModel.newPassword
          }
        });

        if (historyCheck.data.status === 'error') {
          Swal.fire({
            title: 'Tidak Dibenarkan!',
            text: historyCheck.data.message,
            icon: 'warning',
            confirmButtonText: 'OK'
          });
          return;
        }

        // 2. Tukar kata laluan
        const response = await login_service.resetPassword({
          request: {  // Pastikan juga resetPassword guna struktur sama
            icNumber: this.userToReset.icNumber,
            newPassword: this.resetPasswordModel.newPassword
          }
        });

        if (response.data.status === 'success') {
          this.$bvModal.hide('resetPasswordModal');

          // Log masuk semula
          const loginResponse = await login_service.loginPublic({
            request: {
              icNumber: this.userToReset.icNumber,
              password: this.resetPasswordModel.newPassword
            }
          });

          // if (loginResponse.data.status === 'success') {
          //   const userData = loginResponse.data.data;
          //   const buidagensi = userData.organisasi || 'Orang Awam';
          //   const userDataForStorage = {
          //     icNumber: userData.icNumber,
          //     nama: userData.nama,
          //     peranan: userData.peranan,
          //     buidagensi: buidagensi,
          //     id: userData.id,
          //     valid: true,
          //     userType: userData.userType,
          //     emel: userData.emel,
          //     reset_pass: userData.reset_pass
          //   };
          //   localStorage.setItem('user', JSON.stringify(userDataForStorage));
          //   Store.commit('setUser', userDataForStorage);
          //   Store.commit('saveToken', userData.id);
          //   await this.$router.push('/profile');
          //   this.$router.push('/senarai-projek');
          // }
          if (loginResponse.data.status === 'success') {
            const userData = loginResponse.data.data;
            const buidagensi = userData.organisasi || 'Orang Awam';
            const userDataForStorage = {
              icNumber: userData.icNumber,
              nama: userData.nama,
              peranan: userData.peranan,
              buidagensi: buidagensi,
              id: userData.id,
              valid: true,
              userType: userData.userType,
              emel: userData.emel,
              reset_pass: userData.reset_pass
            };

            localStorage.setItem('user', JSON.stringify(userDataForStorage));
            Store.commit('setUser', userDataForStorage);
            Store.commit('saveToken', userData.id);

            // Sembunyikan modal reset
            this.$bvModal.hide('resetPasswordModal');

            // Tunjukkan modal berjaya
            this.$bvModal.show('passwordChangedSuccessModal');

            // JANGAN redirect terus — biar pengguna klik "Tutup"
          } else {
            Swal.fire({
              title: 'Ralat!',
              text: 'Gagal log masuk semula selepas tukar kata laluan.',
              icon: 'error'
            });
          }
        }
      } catch (error) {
        // console.error('Error in submitResetPassword:', error);

        let msg = 'Terdapat masalah teknikal.';
        if (error.response && error.response.data && error.response.data.message) {
          msg = error.response.data.message;
        }

        Swal.fire({
          title: 'Ralat!',
          text: msg,
          icon: 'error',
          confirmButtonText: 'OK'
        });
      } finally {
        this.loadingResetPassword = false;
      }
    }
  }
};
</script>

<style>
@font-face {
  font-family: 'FranklinGothic Demi';
  src: url('~@/assets/font/franklingothic_demi.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

/* Load Font Awesome locally */
@import url('~@/assets/fontawesome/css/all.min.css');

.system-title {
  font-family: 'FranklinGothic Demi', 'Arial Narrow', Arial, sans-serif;
}

.header {
  background: white !important;
}

.shadow-lg {
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.150) !important;
}

/* Sweetalert custom styles */
.swal2-popup {
  font-family: inherit !important;
}

.swal2-popup .form-control {
  display: block;
  width: 100%;
  padding: 0.5rem 0.75rem;
  font-size: 0.9rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out;
}

.swal2-popup .form-control:focus {
  border-color: #1e3a8a;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(30, 58, 138, 0.25);
}

.swal2-popup .form-group {
  margin-bottom: 1rem;
}

.swal2-popup label {
  display: block;
  margin-bottom: 0.5rem;
  color: #1e3a8a;
}

/* Equal width tabs */
.login-tabs {
  display: flex;
  width: 100%;
}

.login-tabs>li {
  flex: 1;
}

.login-tabs>li>button {
  width: 100%;
  text-align: center;
  padding: 15px;
  font-weight: bold;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
}

.login-tabs .active-tab {
  background-color: #fff;
  border: none;
  font-weight: bold;
}

.nav-tabs .nav-link {
  border: none;
  background: #e9e9e9;
}

.nav-tabs .nav-link.active {
  background-color: #fff;
}

.btn-primary {
  background: linear-gradient(87deg, #1e3a8a 0%, #1a2b5d 100%) !important;
  border: none !important;
}

.btn-primary:hover {
  background: linear-gradient(87deg, #1a2b5d 0%, #1e3a8a 100%) !important;
  border: none !important;
}

.text-light {
  color: #000000 !important;
}

.text-dark {
  color: #1e3a8a !important;
}

/* Tab Styling */
.login-tabs .nav-link {
  color: #1e3a8a !important;
  font-weight: 600;
  font-size: 0.95rem;
  border: none !important;
  background: transparent !important;
  border-radius: 15px 15px 0 0 !important;
  padding: 12px 20px !important;
  margin: 0 2px;
}

.login-tabs .nav-link:hover {
  background: rgba(30, 58, 138, 0.1) !important;
  border: none !important;
}

.login-tabs .nav-link.active,
.login-tabs .active-tab {
  background: linear-gradient(87deg, #1e3a8a 0%, #1a2b5d 100%) !important;
  color: white !important;
  border: none !important;
}

.login-tabs {
  border-bottom: 2px solid #1e3a8a;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 20px 20px 0 0;
  padding: 5px 10px 0 10px;
}

.tab-content {
  background: transparent;
  border: none;
}

/* Register button styling */
.btn-outline-primary {
  border-color: #1e3a8a !important;
  color: #1e3a8a !important;
  font-weight: 600;
}

.btn-outline-primary:hover {
  background-color: #1e3a8a !important;
  border-color: #1e3a8a !important;
  color: white !important;
}

.ml-lg-5 {
  margin-left: 3rem;
}

/* Responsive adjustments */
@media (max-width: 992px) {
  .bg-white>div {
    flex-direction: column;
    text-align: center;
  }

  .bg-white>div>div:first-child {
    margin-bottom: 10px;
  }

  .bg-white>div>div:last-child {
    width: auto !important;
  }
}

@media (max-width: 768px) {
  .bg-white>div>div:first-child img {
    width: 60px !important;
  }

  .bg-white>div>div:first-child img:last-child {
    width: 80px !important;
    margin-left: 5px !important;
  }

  h1 {
    font-size: 1.2rem !important;
  }
}

@media (max-width: 768px) {
  .bg-white>.container>.row>.col-lg-6 {
    margin-top: 15px;
    margin-bottom: 20px !important;
  }

  .bg-white>.container>.row>.col-lg-6 img {
    max-width: 80% !important;
  }
}

@media (min-width: 992px) {
  .bg-white>.container>.row>.col-lg-6 {
    margin-top: 0;
    margin-bottom: 0;
  }

  .bg-white>.container>.row>.col-lg-6 img {
    max-width: 500px !important;
  }

  hr {
    margin: 0 !important;
  }
}

@media (max-width: 768px) {

  html,
  body {
    -webkit-text-size-adjust: none !important;
    -webkit-tap-highlight-color: transparent !important;
  }
}

@media (max-width: 768px) {
  .target-class {
    border: none !important;
  }
}

@media (max-width: 768px) {
  hr {
    display: none !important;
  }
}

@media (max-width: 768px) {
  .desktop-header {
    display: none !important;
  }
}

@media (max-width: 768px) {
  .desktop-header img {
    width: 90px !important;
  }

  .desktop-header img:last-child {
    width: 110px !important;
    margin-left: 8px !important;
  }
}

@media (max-width: 768px) {
  .desktop-header>div {
    flex-direction: column !important;
    align-items: center !important;
    text-align: center;
  }

  .desktop-header img {
    width: 120px !important;
    max-width: none !important;
  }

  .desktop-header img:last-child {
    width: 150px !important;
    margin-left: 0 !important;
    margin-top: 10px;
  }
}

@font-face {
  font-family: 'FranklinGothic Demi';
  src: url('~@/assets/font/franklingothic_demi.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

/* Load Font Awesome locally */
@import url('~@/assets/fontawesome/css/all.min.css');

/* Other styles */
.system-title {
  font-family: 'FranklinGothic Demi', 'Arial Narrow', Arial, sans-serif;
}

.text-danger {
  font-size: 0.85rem;
  color: #dc3545;
  margin-top: 0.25rem;
}

.custom-tooltip {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 5px;
  padding: 10px;
  margin-top: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.progress {
  border-radius: 4px;
}

.progress-bar {
  transition: width 0.3s ease;
}

.form-label {
  font-weight: 600;
  color: #1e3a8a;
  margin-bottom: 5px;
}
</style>
